export { default } from "./BlurReveal"
export type { BlurRevealProps } from "./BlurReveal"
